export { InvestmentsServicesPlatformsPage as default } from "@nvb/ui";
